import {Button, Card, CardActions, CardContent, CardProps, Chip, Typography} from '@material-ui/core';
import React from 'react';
import {CardStyles} from './CardStyles';
import {Group, User} from '../../graphql';
import {Link} from 'react-router-dom';

interface UserCardProps extends CardProps {
  user: User;
  deleteUser?: Function;
}

export const UserCard = ({user, deleteUser}: UserCardProps) => {
  const classes = CardStyles();
  const disabled = !user.enabled;

  const handleDelete = () => {
    deleteUser && deleteUser(user.id);
  };

  const toggleEnabled = () => {
    // setUserEnabled && setUserEnabled(user.id, !user.enabled);
  };

  const cls = [
    classes.card,
    disabled ? classes.disabled : '',
  ].join(' ');

  return <Card key={user.id} className={cls}>
    <CardContent>
      <Typography className={classes.title}>
        {user.firstName} {user.lastName}
      </Typography>

      <Typography className={classes.info}>
        {user.email}
      </Typography>

      <Typography className={classes.pad10}>
        {user.username}
      </Typography>

      <Typography className={classes.pad10} component="div">
        {user?.groups?.map((group: Group | null) => (
          <Chip key={group?.id} size="small" className={classes.chip} label={group?.name}/>
        ))}
      </Typography>

      <Typography className={classes.info}>
        {user.id}<br/>
        {user.createdAt}<br/>
        {user.updatedAt}
      </Typography>

      {/*<FormControlLabel label="Enabled" control={*/}
      {/*  <Switch checked={user.enabled} onChange={toggleEnabled}/>*/}
      {/*}/>*/}

    </CardContent>

    <CardActions className={classes.actions}>
      <Link to={`/user/edit/${user.id}`}>
        <Button disabled={disabled} size="small">Edit</Button>
      </Link>
      {/*<Button disabled={disabled} size="small" onClick={handleDelete}>Delete</Button>*/}
    </CardActions>

  </Card>;
};
